import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Contactheader from '../components/Contact/Contactheader'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'

const Contactpage = () => {
  return (
    <div>

    <Navbar/>
    <Contactheader/>
    <Contact/>
    <Footer/>


    </div>
  )
}

export default Contactpage
